import React, { useEffect, useState, useMemo } from "react";
import NotEligibleView from "./components/NotEligibleView";
import { useParams } from "react-router-dom";
import Error from "../../../shared/components/Error";
import { withTranslation } from "react-i18next";
import { addToGoogleDataLayer } from "../../../shared/const/utls.js";

const NotEligible = ({ i18n }) => {
  const [isError, setIsError] = useState(false);
  const params = useParams();

  useEffect(() => {
    if (i18n?.language === "en") {
      document.title =
        "Unfortunately you don't qualify - HARP- Government of Nova Scotia";
    } else {
      document.title =
        "Malheureusement, vous n’êtes pas admissible – PAC – Gouvernement de la Nouvelle-Écosse";
    }
  }, [i18n.language]);

  // const question = useMemo(() => {
  //   return JSON?.parse(
  //     new URLSearchParams(history.location.search)?.get("question") || false
  //   );
  // }, [history]);

  const question = params?.search?.substring(10);

  useEffect(() => {
    try {
      addToGoogleDataLayer(
        `not-eligible-${question}`,
        "HARP Application",
        i18n.language
      );
      window.scrollTo(0, 0);
    } catch (e) {
      console.log(e);
    }
  }, [i18n.language, question]);

  return isError ? <Error /> : <NotEligibleView setIsError={setIsError} />;
};

export default withTranslation("common")(NotEligible);
